import { Component, computed, inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GridService } from '@services/grid.service';
import { ReportColumnVisibilityService } from '@services/report-column-visibility.service';
import { ReportSingleService } from '@services/report-single.service';
import { ReportSingleEmptyStateComponent } from './report-single-empty-state/report-single-empty-state.component';
import { ReportSingleFiltersComponent } from './report-single-filters/report-single-filters.component';
import { ReportSingleHeaderComponent } from './report-single-header/report-single-header.component';
import { ReportSingleTabsComponent } from './report-single-tabs/report-single-tabs.component';

@Component({
    selector: 'app-report-single',
    standalone: true,
    imports: [
        ReportSingleHeaderComponent,
        ReportSingleFiltersComponent,
        ReportSingleEmptyStateComponent,
        ReportSingleTabsComponent
    ],
    providers: [ReportSingleService, ReportColumnVisibilityService],
    templateUrl: './report-single.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./report-single.component.scss']
})
export class ReportSingleComponent implements OnInit, OnDestroy {
    private readonly service = inject(ReportSingleService);
    private readonly route = inject(ActivatedRoute);
    private readonly gridService = inject(GridService);

    readonly configuration = computed(() => this.service.configuration());
    readonly showContent = computed(() => this.service.hasRunTemplateReport() || !!this.service.customReportId());

    ngOnInit(): void {
        this.route.paramMap.subscribe(async (params) => {
            const reportTemplate = params.get('reportTemplate') ?? '';
            const id = params.get('id');
            const token = params.get('token') ?? '';

            this.service.reportTemplateName.set(reportTemplate);
            this.service.customReportId.set(id ? Number.parseInt(id, 10) : undefined);
            this.service.catalogReportId.set(token || undefined);

            if (!reportTemplate) return;
            this.service.setConfiguration(reportTemplate);
            this.service.bindFiltersToEditors();
            await this.service.initializeReport();
        });
    }

    ngOnDestroy(): void {
        this.gridService.removeGridApi();
    }
}
